var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5923 1.81984H8.32974V0.333008H3.8993V1.81984H0.636719V4.16747H11.5923V1.81984ZM5.07311 1.50682H7.15593V1.81984H5.07311V1.50682Z",
    fill: "#B51111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5491 8.71886L10.7706 5.3418H1.45703L2.20107 16.6887H6.6683C6.08683 15.8644 5.74482 14.8596 5.74482 13.7764C5.74482 11.0712 7.87702 8.85459 10.5491 8.71886Z",
    fill: "#B51111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8103 9.88574C8.66515 9.88574 6.91992 11.631 6.91992 13.7761C6.91992 15.9213 8.66515 17.6665 10.8103 17.6665C12.9555 17.6665 14.7007 15.9213 14.7007 13.7761C14.7007 11.6309 12.9555 9.88574 10.8103 9.88574ZM12.9301 15.0659L12.1001 15.8959L10.8103 14.6061L9.52059 15.8959L8.69058 15.0659L9.98033 13.7761L8.69058 12.4864L9.52059 11.6564L10.8103 12.9461L12.1001 11.6564L12.9301 12.4864L11.6403 13.7761L12.9301 15.0659Z",
    fill: "#B51111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.b2c43043.svg";
export { ForwardRef as ReactComponent };